import { Tag } from "antd";

/**
 * Red DELETED tag shown next to partner name/ID on historical tabs
 * when the linked rider is soft-deleted.
 */
export default function DeletedTag({ show = false }) {
  if (!show) return null;
  return (
    <Tag color="red" style={{ marginInlineStart: 6, fontSize: 11, lineHeight: "18px", padding: "0 6px" }}>
      DELETED
    </Tag>
  );
}

/**
 * Partner name (or ID) with optional DELETED tag.
 */
export function PartnerLabel({ name, deleted }) {
  if (!name) return "—";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap" }}>
      {name}
      <DeletedTag show={deleted} />
    </span>
  );
}
